<template>
  <div>
    <shared-view-announcement></shared-view-announcement>
  </div>
</template>

<script>
import SharedViewAnnouncement from '@/views/Shared/Announcement/View'
import { EventBus } from '@/../eventbus.js'

export default {
  name: 'Window.Dashboard.Announcement.View',
  components: {
    SharedViewAnnouncement
  },
  mounted () {
    EventBus.$emit('initAnnouncementViewData', this.$route.params.id)
  }
}
</script>

<style scoped>

</style>
